<template>
  <v-card flat>
    <v-layout class="pb-3 pt-2" justify-start row wrap>
      <v-text-field
        class="pa-3 ma-3"
        v-model="search"
        append-icon="search"
        label="Поиск"
        single-line
      ></v-text-field>


      <v-layout justify-end row wrap>
        <v-btn @click="getItems()" color="primary">
          <v-icon class="material-icons">
            autorenew
          </v-icon>
        </v-btn>
        <v-btn class="primary" @click="printPDF" v-if="allowed('admin|petition|petition|petition_create_council-make-list-file', 'make_list_file')" :disabled="generatePdf">
          <span v-if="!generatePdf">
            Сформировать csv
          </span>
          <span v-else style="padding-left: 65px; width: 149px; align-content: center; text-align: center;">
            <semipolar-spinner
              :animation-duration="2000"
              :size="20"
              color="#1935ff"
            />
          </span>
        </v-btn>
      </v-layout>

    </v-layout>

    <v-card-text class="pb-3 pt-1">
      <v-layout justify-center>
        <v-flex>

          <v-data-table
            :headers="local_admin ? adm_headers: headers"
            :items="items"
            :search="search"
            :rows-per-page-items="[15,25,35,{text:'Все', value:-1}]"
            class="elevation-1  "
            no-data-text="Нет данных"
            rows-per-page-text="Число элементов"
            :loading="!loadingPage"
          >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <tr @click="goToPath(props.item)" v-if="local_admin" >
                <td class="justify-center">{{props.item.created}}</td>
                <td class="justify-center">{{props.item.status}}</td>
                <td class="justify-center">{{props.item.department}}</td>
                <td class="justify-center">{{props.item.responsible}}</td>
                <td class="justify-center">
                  <template v-for="el in props.item.departments">
                    {{el.uid}}
                  </template>
                </td>
                <td class="justify-center">
                  <template v-for="el in props.item.departments">
                    {{el.speciality}}-{{el.branch}}
                  </template>
                </td>
              </tr>
              <tr @click="goToPath(props.item)" v-else>
                <td class="justify-center">{{props.item.created}}</td>
                <td class="justify-center">{{props.item.status}}</td>
                <td class="justify-center">{{props.item.responsible}}</td>
                <td class="justify-center">
                  <template v-for="el in props.item.departments">
                    {{el.uid}}
                  </template>
                </td>
                <td class="justify-center">
                  <template v-for="el in props.item.specialities">
                    {{el.speciality}}({{el.branch}})
                  </template>
                </td>
              </tr>
            </template>
<!--            <template slot="items" slot-scope="props"  >-->

<!--            </template>-->
            <template slot="pageText" slot-scope="item">
              {{item.pageStart}} - {{item.pageStop}} из {{item.itemsLength}}
            </template>
            <template slot="no-data">
              <v-btn @click="getItems()" color="primary">Обновить</v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
  import urls from "../../urls.js"
  import urlsW from "../../urlsW.js"
  import UserDataMixin from '../../../../mixins/UserDataMixin'
  import {makeGetRequest, makePostRequest, makeProfileUrl} from "../../../../helper";
  import urlU from "../../urlsU.js"
  import {SemipolarSpinner} from 'epic-spinners'

    export default {
        name: "AppList",
        components: {SemipolarSpinner},
      mixins: [UserDataMixin],
      props: {
            local_admin: Boolean,
      },
      data: function () {
        return {
          selected: {},
          opened_form: false,
          generatePdf: false,
          search: '',
          statisttic: {},
          departments: [],
          headers: [
            {
                text: 'Дата подачи',
                align: 'justify-center',
                sortable: false,
                value: 'created',
            },
            {
              text: 'Статус заявки',
              align: 'justify-center',
              sortable: false,
              value: 'status',
            },
            {
              text: 'Ответственный',
              align: 'justify-center',
              sortable: false,
              value: 'responsible',
            },
            {
                text: 'Подразделения',
                align: 'justify-center',
                sortable: false,
                value: 'departments',
            },
            {
                text: 'Специальности',
                align: 'justify-center',
                sortable: false,
                value: 'specialities',
            },
          ],
          adm_headers:[
            {
                text: 'Дата подачи',
                align: 'justify-center',
                sortable: false,
                value: 'date',
            },
            {
                text: 'Статус заявки',
                align: 'justify-center',
                sortable: false,
                value: 'status',
            },
            {
                text: 'Подразделения инициатора',
                align: 'justify-center',
                sortable: false,
                value: 'department',
            },
            {
                text: 'Ответственный',
                align: 'justify-center',
                sortable: false,
                value: 'responsible',
            },
          ],

          URL_LIST: makeProfileUrl(urls.getUrl('admin|petition|petition|petition_create_council-list', 'list')),
        }
      },
      methods: {
        setDepartment(depts){
            for (var key in depts) {
                var dep = this.departments.find(department => department.value === depts[key].uid);
                depts[key].uid = dep.text
            }
        },
        loadDepartments(){
            return this.getChoices(
                urlsW.getUrl('selectors|department|department|uid', 'get').replace('<organization_id>', '1'),
            ).then(choices => {
                return new Promise(resolve => {
                    this.departments = choices;
                    resolve()
                })
            });
        },
        getItems: function () {
          let url = makeProfileUrl(
            this.URL_LIST
          );
          makeGetRequest(url)
            .then(resp => {
              return resp.json()
            }).then(json => {
              let uids = [];
              let list = json;
              this.items = list;
              list.forEach(item => {
                  uids.push(item.responsible)
              });
              // console.log(uids)
              makePostRequest(
                  urlsW.getUrl('external|employee|worker|main|position|title', 'post'),
                  {'uids': uids}
              ).then(resp => resp.json()).then(json => {
                list.forEach(fitem => {
                  let finded = json.find(item => fitem.responsible === item.uid);
                  fitem.responsible = finded.title;
                    this.setDepartment(fitem.departments)
                });
                this.items = list;
                this.loadingPage = true;
              });
          });
        },
        updateItem: function (item) {
          this.selected = item;
          this.opened_form = true
        },
        closedForm: function () {
          this.selected = {};
          this.opened_form = false
        },
        allowed(urlname, action) {
          return urls.getUrlAllowed(urlname, action)
        },
        goToPath(path){
          this.$router.push({name: "DetailApplication", params: {id: path.id}})
        },
        download(content, fileName, contentType) {
            var a = document.createElement("a");
            a.href = URL.createObjectURL(content);
            a.download = fileName;
            a.click();
        },
        printPDF(){
            this.generatePdf = true;
            let status = true;
            const type = "application/csv";
            const name = 'file.csv';
            makeGetRequest(
                urls.getUrl('admin|petition|petition|petition_create_council-make-list-file', 'make_list_file').replace('<id>', this.$route.params.id),
            ) .then(resp => {
                if (!resp.ok) {
                    status = false;
                }
                return resp.blob();
            }) .then(blob => {
                this.download(blob, name, type);
                this.generatePdf = false;
            })

        },
      },
      created() {
        this.$store.commit('mainpage/changeTitle', 'Список поданых заявлений:');
        this.loadDepartments().then(() => {
            this.getItems();
        });
      },

    }
</script>

<style scoped>

</style>
